import { defineComponent as n, openBlock as p, createBlock as r, unref as m, mergeProps as i, withCtx as l, createElementVNode as t } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconShoppingBagEmpty",
  __name: "IconShoppingBagEmpty",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const a = o;
    return (h, e) => (p(), r(m(c), i(a, { "view-box": "0 0 24 24" }), {
      default: l(() => [...e[0] || (e[0] = [
        t("path", { d: "M18.25 5.75H5.75V16.5a1.75 1.75 0 0 0 1.75 1.75h9a1.75 1.75 0 0 0 1.75-1.75V5.75m1.5 10.75a3.25 3.25 0 0 1-3.25 3.25h-9a3.25 3.25 0 0 1-3.25-3.25v-11A1.25 1.25 0 0 1 5.5 4.25h13a1.25 1.25 0 0 1 1.25 1.25v11" }, null, -1),
        t("path", { d: "M12 12.25a4.75 4.75 0 0 0 4.744-4.5A.24.24 0 0 0 16.5 7.5h-1a.266.266 0 0 0-.26.25 3.25 3.25 0 0 1-6.48 0A.266.266 0 0 0 8.5 7.5h-1a.24.24 0 0 0-.244.25A4.75 4.75 0 0 0 12 12.25" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
